import Chip from '@mui/material/Chip';
import React from 'react';
import {
	INVOICE_STATUS_CARRIED_FORWARD,
	INVOICE_STATUS_ERROR,
	INVOICE_STATUS_INVALIDATED,
	INVOICE_STATUS_OUTSTANDING,
	INVOICE_STATUS_PAID,
	INVOICE_STATUS_SETTLED,
	INVOICE_STATUS_UNFULFILLED,
	INVOICE_STATUS_WRITTEN_OFF,
	INVOICE_STATUS_ZERO_DUE,
} from '../data/labelsAndMessages';

type InvoiceState =
	| 'paid'
	| 'writtenOff'
	| 'zeroDue'
	| 'invalidated'
	| 'outstanding'
	| 'settled'
	| 'unfulfilled'
	| 'carriedForward';

interface Props {
	state: InvoiceState | string;
}

export const formatInvoiceStatus = (status: InvoiceState) => {
	switch (status) {
		case 'invalidated':
			return INVOICE_STATUS_INVALIDATED();
		case 'paid':
			return INVOICE_STATUS_PAID();
		case 'writtenOff':
			return INVOICE_STATUS_WRITTEN_OFF();
		case 'zeroDue':
			return INVOICE_STATUS_ZERO_DUE();
		case 'carriedForward':
			return INVOICE_STATUS_CARRIED_FORWARD();
		case 'outstanding':
			return INVOICE_STATUS_OUTSTANDING();
		case 'unfulfilled':
			return INVOICE_STATUS_UNFULFILLED();
		case 'settled':
			return INVOICE_STATUS_SETTLED();
		default:
			return INVOICE_STATUS_ERROR();
	}
};

const InvoiceStateChip = (props: Props) => {
	const { state } = props;
	switch (state) {
		case 'invalidated':
			return (
				<Chip
					label={INVOICE_STATUS_INVALIDATED()}
					color='neutral'
					variant='filled'
					size='small'
				/>
			);
		case 'paid':
			return (
				<Chip
					label={INVOICE_STATUS_PAID()}
					color='neutralSuccess'
					variant='filled'
					size='small'
				/>
			);
		case 'writtenOff':
			return (
				<Chip
					label={INVOICE_STATUS_WRITTEN_OFF()}
					color='neutralInfo'
					variant='filled'
					size='small'
				/>
			);
		case 'zeroDue':
			return (
				<Chip
					label={INVOICE_STATUS_ZERO_DUE()}
					color='neutralInfo'
					variant='filled'
					size='small'
				/>
			);
		case 'carriedForward':
			return (
				<Chip
					label={INVOICE_STATUS_CARRIED_FORWARD()}
					color='neutralInfo'
					variant='filled'
					size='small'
				/>
			);
		case 'outstanding':
			return (
				<Chip
					label={INVOICE_STATUS_OUTSTANDING()}
					color='neutralWarning'
					variant='filled'
					size='small'
				/>
			);
		case 'unfulfilled':
			return (
				<Chip
					label={INVOICE_STATUS_UNFULFILLED()}
					color='neutralWarning'
					variant='filled'
					size='small'
				/>
			);
		case 'settled':
			return (
				<Chip
					label={INVOICE_STATUS_SETTLED()}
					color='neutralInfo'
					variant='filled'
					size='small'
				/>
			);
		default:
			return <Chip label={INVOICE_STATUS_ERROR()} color='error' />;
	}
};

export default InvoiceStateChip;
